import { createdBoxQueries } from '@/entities/sets/created';
import useVisible from '@/shared/hooks/useVisible';
import { sendTraceLog } from '@/shared/log/tracker';
import { Modal } from '@/shared/ui';
import { showToast } from '@/shared/utils/toast';
import { CreatedRangePopup } from '@/widgets/modal';
import { FC, useState } from 'react';

interface CreatedRangeProps {
    children?: React.ReactNode;
    disabled?: boolean;
    styles: {
        button?: string;
    };
    articleList: string[];
    onArticlesSet?: () => {};
}

export const CreatedRange: FC<CreatedRangeProps> = ({
    children,
    styles,
    disabled,
    articleList,
}) => {
    const [isCreatedRangeVisible, setIsCreatedRangeVisible] = useVisible();
    const [rangeList, setRangeList] = useState<API.CreatedBoxRange.MetaData[]>([]);

    const { mutate: rangeMutate } = createdBoxQueries.postCreatedBoxRange();

    const onRange = async () => {
        if (!articleList || articleList.length === 0) {
            sendTraceLog('', '', '', 'debug', `[SBANK_LOG] 출제 범위의 요청 파라메터가 없습니다.`);
            return;
        }
        rangeMutate(
            {
                articleIds: articleList ?? [],
            },
            {
                onSuccess: (res) => {
                    if (res?.data?.vo) {
                        setRangeList(res?.data?.vo);
                        setIsCreatedRangeVisible();
                    } else {
                        showToast('출제 범위 조회 실패', 2000, 'error');
                    }
                },
                onError: () => showToast('출제 범위 조회 실패', 2000, 'error'),
            }
        );
    };

    const clickCreatedRangeBtn = () => {
        onRange();
    };

    return (
        <>
            <Modal open={isCreatedRangeVisible} onClose={setIsCreatedRangeVisible} isCustom={true}>
                <CreatedRangePopup rangeList={rangeList} />
            </Modal>
            <button
                type="button"
                className={styles.button}
                disabled={disabled}
                onClick={() => clickCreatedRangeBtn()}
            >
                {children && children}
            </button>
        </>
    );
};
